import { AppStatusConfig } from '../models/application-status-config.interface';

export class AppStatus {
	static APP_STATUSES: { [statusId: number]: AppStatusConfig } = {
		0: {
			id: 0,
			title: 'Default',
			color: 'gray',
			adminColor: 'gray',
			icon: 'icon-statusComplete'
		},
		90: {
			id: 90,
			title: 'Saved — Not Submitted',
			color: 'gray',
			adminColor: 'gray',
			icon: 'icon-statusComplete'
		},
		95: {
			id: 95,
			title: 'Forwarded to HR For Review',
			color: 'gray',
			adminColor: 'gray',
			icon: 'icon-statusApproved'
		},
		100: {
			id: 100,
			title: 'Submitted — Pending Review',
			color: 'green',
			adminColor: 'yellow',
			icon: 'icon-statusReview'
		},
		110: {
			id: 110,
			title: 'Submitted — Incomplete',
			color: 'red',
			adminColor: 'red',
			icon: 'icon-statusComplete'
		},
		120: {
			id: 120,
			title: 'Approved',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		},
		125: {
			id: 125,
			title: 'Forwarded to Supervisor For Review',
			color: 'green',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		130: {
			id: 130,
			title: 'Virtual Credit Card Issued',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		},
		135: {
			id: 135,
			title: 'Carryover Payment Approved',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		},
		300: {
			id: 300,
			title: 'Materials Sent',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		},
		301: {
			id: 301,
			title: 'Resend Materials',
			color: 'red',
			adminColor: 'red',
			icon: 'icon-statusComplete'
		},
		400: {
			id: 400,
			title: 'Letter of Credit (LOC) Issued',
			color: 'green',
			adminColor: 'yellow',
			icon: 'icon-statusApproved'
		},
		425: {
			id: 425,
			title: 'Payment Review',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusReview'
		},
		450: {
			id: 450,
			title: 'Payment Processing Incomplete — Information Needed',
			color: 'red',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		500: {
			id: 500,
			title: 'Payment/Reimbursement In Progress',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusComplete'
		},
		510: {
			id: 510,
			title: 'Payment Approved — Funding in Progress',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		},
		520: {
			id: 520,
			title: 'Payment Complete',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		},
		530: {
			id: 530,
			title: 'Payment Complete — Completion Documents Required',
			color: 'green',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		540: {
			id: 540,
			title: 'Repayment Required',
			color: 'yellow',
			adminColor: 'yellow',
			icon: 'icon-statusComplete'
		},
		545: {
			id: 545,
			title: 'Sent to Collections',
			color: 'red',
			adminColor: 'gray',
			icon: 'icon-statusComplete'
		},
		710: {
			id: 710,
			title: 'Testing in Progress',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusComplete'
		},
		715: {
			id: 715,
			title: 'Testing Complete',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusComplete'
		},
		720: {
			id: 720,
			title: 'Certificate Issued',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusComplete'
		},
		900: {
			id: 900,
			title: 'Closed',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusComplete'
		},
		910: {
			id: 910,
			title: 'Cancelled',
			color: 'grayLight',
			adminColor: 'grayLight',
			icon: 'icon-statusCancelled'
		},
		920: {
			id: 920,
			title: 'Void',
			color: 'gray',
			adminColor: 'gray',
			icon: 'icon-statusComplete'
		},
		930: {
			id: 930,
			title: 'Denied',
			color: 'red',
			adminColor: 'red',
			icon: 'icon-statusDenied'
		},
		940: {
			id: 940,
			title: 'No Payment Processing',
			color: 'green',
			adminColor: 'green',
			icon: 'icon-statusApproved'
		}
	};
}
